export default __webpack_public_path__ + "static/media/verify-email.66ef37d3.svg";